// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__3nLtl","charity_list":"Results_charity_list__1HEIw","question":"Results_question__1rQcn","btn_retake":"Results_btn_retake__1RunH"};